import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchGet, isInteger } from '../../common/common';
import { updateCheckoutDet, updateUserInfo } from '../../actions/search-actions';
import store from '../../store';

import './checkout.css';

import LineInp from '../common/lineinput';
import Radio from '../common/radio';
import Check from '../common/checkbox';
// import MobImg from '../../img/mobile.svg';

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            queryData: '{}',
            // onwardName: ['', '', ''],
            // onwardAge: ['', '', ''],
            // onwardGender: ['', '', ''],
            // returnName: ['', '', ''],
            // returnAge: ['', '', ''],
            // returnGender: ['', '', ''],
            mobile: '',
            email: '',
            payopt: '',
            insuranceVal: 0,
            insurance: 'on',
            onwardFare: 0,
            onwardGst: 0,
            onwardSc: 0,
            returnFare: 0,
            returnGst: 0,
            returnSc: 0,
            discount: 0,
            onwardConvenienceCharge : 0,
            returnConvenienceCharge : 0
        }
    }

    // componentWillMount() {
    //     srchPrm = getSearchParams();
    // }

    componentDidMount() {
        // console.log(this.props.search.order);
        if (this.props.search.order.length === 0) {
            const url = window.url + '/api/expco/getOrderDetails?token=' + this.props.match.params.token;
            const that = this;
            fetchGet(url).then(function(data) {
                let onwardFare = that.state.onwardFare;
                let onwardGst = that.state.onwardGst;
                let onwardSc = that.state.onwardSc;
                let returnFare = that.state.returnFare;
                let returnGst = that.state.returnGst;
                let returnSc = that.state.returnSc;
                let discount = that.state.discount;
                let onwardConvenienceCharge = that.state.onwardConvenienceCharge;
                let returnConvenienceCharge = that.state.returnConvenienceCharge;
                Object.keys(data.onward.seatDetails).forEach(el => {
                    data.onward.seatDetails[el]['convenienceCharge'] = data.onward.seatDetails[el].convenienceCharge;
                    data.onward.seatDetails[el]['name'] = '';
                    data.onward.seatDetails[el]['age'] = '';
                    data.onward.seatDetails[el]['isMale'] = data.onward.seatDetails[el].gender && data.onward.seatDetails[el].gender.toLowerCase() === 'm';
                    data.onward.seatDetails[el]['isFemale'] = data.onward.seatDetails[el].gender && data.onward.seatDetails[el].gender.toLowerCase() === 'f';
                    onwardFare += parseInt(data.onward.seatDetails[el].fare, 10);
                    onwardGst += parseInt(data.onward.seatDetails[el].serviceTax, 10);
                    onwardConvenienceCharge += parseInt(data.onward.seatDetails[el].convenienceCharge, 10);
                });
                onwardSc += data.onward.serviceCharge ? parseInt(data.onward.serviceCharge, 10) : 0;
                discount += parseInt(data.onward.discountAmount, 10);
                if (data.return.seatDetails && Object.keys(data.return.seatDetails).length > 0) {
                    Object.keys(data.return.seatDetails).forEach(el => {
                        data.return.seatDetails[el]['convenienceCharge'] = data.return.seatDetails[el].convenienceCharge;
                        data.return.seatDetails[el]['name'] = '';
                        data.return.seatDetails[el]['age'] = '';
                        data.return.seatDetails[el]['isMale'] = data.return.seatDetails[el].gender && data.return.seatDetails[el].gender.toLowerCase() === 'm';
                        data.return.seatDetails[el]['isFemale'] = data.return.seatDetails[el].gender && data.return.seatDetails[el].gender.toLowerCase() === 'f';
                        returnFare += parseInt(data.return.seatDetails[el].fare, 10);
                        returnGst += parseInt(data.return.seatDetails[el].serviceTax, 10);
                        returnConvenienceCharge += parseInt(data.return.seatDetails[el].convenienceCharge, 10);
                    });
                    returnSc += data.return.serviceCharge ? parseInt(data.return.serviceCharge, 10) : 0;
                    discount += parseInt(data.return.discountAmount, 10);
                }
                const count = data.onward.seats.length + (data.return && data.return.seats ? data.return.seats.length : 0);
                const insuranceVal = data.showInsurance ? count * 20 : 0;
                const queryData = JSON.stringify({
                    "hop": "direct",
                    "mode": returnFare ? "roundtrip" : "oneway",
                    "otaId": "0",
                    "FromCityId": "",
                    "ToCityId": "",
                    "fromCityName": data.onward.fromCity,
                    "toCityName": data.onward.toCity,
                    "JourneyDate": data.onward.journeyDate,
                    "NoOfSeats": false,
                    "SearchId": 0,
                    "returnDate": false
                });
                that.setState({ insuranceVal, onwardFare, onwardGst, onwardSc, returnFare, returnGst, returnSc, queryData, discount, onwardConvenienceCharge, returnConvenienceCharge });
                // console.log(data);
                store.dispatch(updateCheckoutDet(data));
            }).catch(function(error) {
                console.log(error);
            });
        } else {
            const ord = this.props.search.order;
            //console.log(ord);
            let onwardFare = this.state.onwardFare;
            let onwardGst = this.state.onwardGst;
            let onwardSc = this.state.onwardSc;
            let returnFare = this.state.returnFare;
            let returnGst = this.state.returnGst;
            let returnSc = this.state.returnSc;
            let discount = this.state.discount;
            let onwardConvenienceCharge = this.state.onwardConvenienceCharge;
            let returnConvenienceCharge = this.state.returnConvenienceCharge;
            Object.keys(ord.onward.seatDetails).forEach(el => {
                ord.onward.seatDetails[el]['convenienceCharge'] = ord.onward.seatDetails[el].convenienceCharge;
                ord.onward.seatDetails[el]['name'] = '';
                ord.onward.seatDetails[el]['age'] = '';
                ord.onward.seatDetails[el]['isMale'] = ord.onward.seatDetails[el].gender && ord.onward.seatDetails[el].gender.toLowerCase() === 'm';
                ord.onward.seatDetails[el]['isFemale'] = ord.onward.seatDetails[el].gender && ord.onward.seatDetails[el].gender.toLowerCase() === 'f';
                onwardFare += ord.onward.seatDetails[el].fare;
                onwardGst += ord.onward.seatDetails[el].serviceTax ? parseInt(ord.onward.seatDetails[el].serviceTax, 10) : 0;
                onwardConvenienceCharge += ord.onward.seatDetails[el].convenienceCharge ? parseInt(ord.onward.seatDetails[el].convenienceCharge, 10) : 0;
            });
            onwardSc += ord.onward.serviceCharge ? parseInt(ord.onward.serviceCharge, 10) : 0;
            discount += ord.onward.discountAmount ? parseInt(ord.onward.discountAmount, 10) : 0;
            if (ord.return && ord.return.seatDetails && Object.keys(ord.return.seatDetails).length > 0) {
                Object.keys(ord.return.seatDetails).forEach(el => {
                    ord.return.seatDetails[el]['convenienceCharge'] = ord.return.seatDetails[el].convenienceCharge;
                    ord.return.seatDetails[el]['name'] = '';
                    ord.return.seatDetails[el]['age'] = '';
                    ord.return.seatDetails[el]['isMale'] = ord.return.seatDetails[el].gender && ord.return.seatDetails[el].gender.toLowerCase() === 'm';
                    ord.return.seatDetails[el]['isFemale'] = ord.return.seatDetails[el].gender && ord.return.seatDetails[el].gender.toLowerCase() === 'f';
                    returnFare += ord.return.seatDetails[el].fare;
                    returnGst += ord.return.seatDetails[el].serviceTax ? parseInt(ord.return.seatDetails[el].serviceTax, 10) : 0;
                    returnConvenienceCharge += ord.return.seatDetails[el].convenienceCharge ? parseInt(ord.return.seatDetails[el].convenienceCharge, 10) : 0;
                });
                returnSc += ord.return.serviceCharge ? parseInt(ord.return.serviceCharge, 10) : 0;
                discount += ord.return.discountAmount ? parseInt(ord.return.discountAmount, 10) : 0;
            }
            const count = ord.onward.seats.length + (ord.return && ord.return.seats ? ord.return.seats.length : 0);
            const insuranceVal = ord.showInsurance ? count * 20 : 0;
            const queryData = JSON.stringify({
                "hop": "direct",
                "mode": returnFare ? "roundtrip" : "oneway",
                "otaId": "0",
                "FromCityId": "",
                "ToCityId": "",
                "fromCityName": ord.onward.fromCity,
                "toCityName": ord.onward.toCity,
                "JourneyDate": ord.onward.journeyDate,
                "NoOfSeats": false,
                "SearchId": 0,
                "returnDate": false
            });
            this.setState({ insuranceVal, onwardFare, onwardGst, onwardSc, returnFare, returnGst, returnSc, queryData, discount, onwardConvenienceCharge, returnConvenienceCharge });
        }
    }

    enterPassDetailsOnwards = () => {
        const ord = this.props.search.order;
        const loop = ord.length !== 0 ? ord.onward.seats : false;
        if (loop) {
            const seats = ord.onward.seatDetails;
            return (
                <div className = 'card'>
                    <h6>Enter Passenger Details { ord.return && ord.return.seats ? '(Onwards)' : ''}</h6>
                    <div>You have selected { loop.length } { loop.length > 1 ? 'seats' : 'seat' } { loop.join(', ') }</div>
                        { loop.map((el, index) => {
                            return (
                                <div className = 'pass-info' key = { index }>
                                    <div style = {{
                                        position: 'relative',
                                        width: '35px',
                                        height: '30px',
                                        fontSize: '0.7rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        paddingBottom: '4px',
                                        border: '1px solid',
                                        borderColor: window.color.searchBoxBgColor
                                    }}>
                                        { el }
                                        <span style = {{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: '5px',
                                            width: '23px',
                                            height: '4px',
                                            background: window.color.searchBoxBgColor
                                        }}></span>
                                    </div>
                                    <LineInp
                                        type = 'text'
                                        value = { seats[el].name }
                                        handleChange = { (e) => {(/^[a-zA-Z ]+$/.test(e.target.value)) || e.target.value === '' ? store.dispatch(updateUserInfo('name', 'onward', el, e.target.value)) : store.dispatch(updateUserInfo('name', 'onward', el, seats[el].name)) } }
                                        placeholder = 'Name'
                                        name = { 'paxName[' + index + ']' }
                                        style = {{ width: '45%' }}
                                        tab = { (index * 4) + 1 }
                                    />
                                    <LineInp
                                        type = 'tel'
                                        value = { seats[el].age }
                                        handleChange = { (e) => { const val = isInteger(parseInt(e.target.value, 10)) ? parseInt(e.target.value, 10) : (!e.target.value ? '' : seats[el].age); store.dispatch(updateUserInfo('age', 'onward', el, val)) }}
                                        placeholder = 'Age'
                                        name = { 'paxAge[' + index + ']' }
                                        style = {{ width: '55px' }}
                                        tab = { (index * 4) + 2 }
                                        max = { 2 }
                                    />
                                    <div style = {{
                                        width: 'calc(55% - 135px)',
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        paddingBottom: '5px'
                                    }}>
                                        <Radio
                                            index = { index }
                                            value = 'Male'
                                            checked = { seats[el].gender === 'Male' }
                                            handleChange = { (event) => store.dispatch(updateUserInfo('gender', 'onward', el, event.target.value)) }
                                            showValue = 'Male'
                                            name = { 'paxGender[' + index + ']' }
                                            tab = { (index * 4) + 3 }
                                            disabled = { seats[el].isFemale }
                                        />
                                        <Radio
                                            index = { index }
                                            value = 'Female'
                                            checked = { seats[el].gender === 'Female' }
                                            handleChange = { (event) => store.dispatch(updateUserInfo('gender', 'onward', el, event.target.value)) }
                                            showValue = 'Female'
                                            name = { 'paxGender[' + index + ']' }
                                            tab = { (index * 4) + 4 }
                                            disabled = { seats[el].isMale }
                                        />
                                    </div>
                                </div>
                            )
                        }) }
                </div>
            )
        } else {
            return (
                <div className = 'card'>
                    Loading...
                </div>
            )
        }
    }

    enterPassDetailsReturn = () => {
        const loop = this.props.search.order.return.seats;
        const seats = this.props.search.order.return.seatDetails;
        const onwardCount = this.props.search.order.onward.seats.length * 4;
        return (
            <div className = 'card'>
                <h6>Enter Passenger Details (Return)</h6>
                <div>You have selected { loop.length } { loop.length > 1 ? 'seats' : 'seat' } { loop.join(', ') }</div>
                    { loop.map((el, index) => {
                        return (
                            <div className = 'pass-info' key = { index }>
                                <div style = {{
                                    position: 'relative',
                                    width: '35px',
                                    height: '30px',
                                    fontSize: '0.7rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    paddingBottom: '4px',
                                    border: '1px solid',
                                    borderColor: window.color.searchBoxBgColor
                                }}>
                                    { el }
                                    <span style = {{
                                        position: 'absolute',
                                        bottom: 0,
                                        left: '5px',
                                        width: '23px',
                                        height: '4px',
                                        background: window.color.searchBoxBgColor
                                    }}></span>
                                </div>
                                <LineInp
                                    type = 'text'
                                    value = { seats[el].name }
                                    handleChange = { (e) => {(/^[a-zA-Z]+$/.test(e.target.value)) || e.target.value === '' ? store.dispatch(updateUserInfo('name', 'return', el, e.target.value)) : store.dispatch(updateUserInfo('name', 'return', el, seats[el].name)) } }
                                    placeholder = 'Name'
                                    name = { 'paxName2[' + index + ']' }
                                    style = {{ width: '45%' }}
                                    tab = { (index * 4) + 1 + onwardCount }
                                />
                                <LineInp
                                    type = 'tel'
                                    value = { seats[el].age }
                                    handleChange = { (e) => store.dispatch(updateUserInfo('age', 'return', el, e.target.value)) }
                                    placeholder = 'Age'
                                    name = { 'paxAge2[' + index + ']' }
                                    style = {{ width: '55px' }}
                                    tab = { (index * 4) + 2 + onwardCount }
                                    max = { 2 }
                                />
                                <div style = {{
                                    width: 'calc(55% - 135px)',
                                    display: 'flex',
                                    justifyContent: 'space-around',
                                    paddingBottom: '5px'
                                }}>
                                    <Radio
                                        index = { index }
                                        value = 'Male'
                                        checked = { seats[el].gender === 'Male' }
                                        handleChange = { (event) => store.dispatch(updateUserInfo('gender', 'return', el, event.target.value)) }
                                        showValue = 'Male'
                                        name = { 'paxGender2[' + index + ']' }
                                        tab = { (index * 4) + 3 + onwardCount }
                                    />
                                    <Radio
                                        index = { index }
                                        value = 'Female'
                                        checked = { seats[el].gender === 'Female' }
                                        handleChange = { (event) => store.dispatch(updateUserInfo('gender', 'return', el, event.target.value)) }
                                        showValue = 'Female'
                                        name = { 'paxGender2[' + index + ']' }
                                        tab = { (index * 4) + 4 + onwardCount }
                                    />
                                </div>
                            </div>
                        )
                    }) }
            </div>
        )
    }

    enterContactDetails = () => {
        const tabCount = this.props.search.order.length !== 0 ? (this.props.search.order.onward.seats.length + (this.props.search.order.return && this.props.search.order.return.seats ? this.props.search.order.return.seats.length : 0)) * 4 : 0;
        return (
            <div className = 'card'>
                <h6>Enter Contact Details</h6>
                <div>Your booking details will be sent to your email address and contact no.</div>
                <div className = 'pass-info'>
                    <div className = 'mob-info'><img src = { '/img/mobile.svg' } alt = 'Mobile' /> +91</div>
                    <LineInp
                        type = 'tel'
                        value = { this.state.mobile }
                        handleChange = { (e) => { const mobile = isInteger(parseInt(e.target.value, 10)) ? parseInt(e.target.value, 10) : (!e.target.value ? '' : this.state.mobile); this.setState({ mobile }) }}
                        placeholder = 'Mobile No'
                        name = 'mobile'
                        style = {{ width: 'calc(100% - 80px)' }}
                        tab = { tabCount + 1 }
                        max = { 10 }
                        validation = 'mobile'
                    />
                </div>
                <div className = 'pass-info'>
                    <LineInp
                        type = 'text'
                        value = { this.state.email }
                        handleChange = { (e) => this.setState({ email: e.target.value }) }
                        placeholder = 'Email ID'
                        name = 'email'
                        style = {{ width: '100%' }}
                        isImg = { true }
                        tab = { tabCount + 2 }
                        validation = 'email'
                    />
                </div>
            </div>
        )
    }

    selPaymentOption = () => {
        if (this.props.search.order && this.props.search.order.pgDetails && this.props.search.order.pgDetails.length > 0) {
            const loop = this.props.search.order.pgDetails;
            return (
                <div className = 'card'>
                    <h6>Select Payment Options</h6>
                    <div>You will be redirected to related website to do this transaction</div>
                    <div className = 'pay-opts'>
                        <div>
                            { loop.map( (el, index) => {
                                return (
                                    <div key = { index } style = { index === loop.length - 1 && index % 2 === 0 ? { width: '100%' } : {} }>
                                        <Radio
                                            value = { el }
                                            checked = { this.state.payopt === el }
                                            handleChange = { (event) => this.setState({ payopt: event.target.value }) }
                                            showValue = { this.getPayVal(el) }
                                            name = 'PGType'
                                        />
                                    </div>
                                )
                            }) }
                        </div>
                    </div>
                    <div>By clicking on "Make Payment" below, I agree to the <a href='/terms_and_conditions' target="_blank" style = {{ color: window.color.searchBoxBgColor }}>Terms and Conditions</a></div>
                    { this.showPayBtn() }
                </div>
            )
        } else {
            return (
                <div className = 'card'>
                    <div>By clicking on "Make Payment" below, I agree to the <a href='/terms_and_conditions' target="_blank" style = {{ color: window.color.searchBoxBgColor }}>Terms and Conditions</a></div>
                    { this.showPayBtn() }
                </div>
            )
        }
    }

    getPayVal = (val) => {
        switch (val) {
            case 'DCnCC':
                return 'Credit / Debit card';
            case 'NB':
                return 'Net Banking';
            case 'PaytmWallet':
                return 'Paytm Wallet';
            case 'JioWallet':
                return 'Jio Money';
            case 'MobikwikWallet':
                return 'MobiKwik Wallet';
            case 'CCAvenue':
                return 'CCAvenue';
            case 'Paytm':
                return 'Paytm';
            case 'billdesk':
                return 'Billdesk';
            case 'ebs':
                return 'Ebs';
            case 'Payu':
                return 'Payu';
            default:
                break;
        }
    }

    showPayBtn = () => {
        let isActive = false;
        const ord = this.props.search.order.length !== 0 ? this.props.search.order : false;
        if (ord) {
            let temp = true;
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach( el => {
                if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
                    temp = false;
                }
            })
            if (temp && ord.return && ord.return.seats) {
                const returns = ord.return.seatDetails;
                Object.keys(returns).forEach( el => {
                    if (!returns[el].name || !returns[el].age || !returns[el].gender) {
                        temp = false;
                    }
                })
            }
            if (temp && (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email)) && this.state.email.length > 0 && this.state.mobile > 5999999999 && (this.state.mobile + '').length === 10) {
                isActive = true
            }
        }
        if ((this.state.payopt || (ord && ord.pgDetails.length === 0)) && isActive) {
            return <div
                style = {{
                    marginTop: '10px',
                    padding: '15px',
                    textAlign: 'center',
                    width: '50%',
                    borderRadius: '3px',
                    color: '#fff',
                    background: window.color.buttonColor,
                    boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
                    fontWeight: 500,
                    cursor: 'pointer',
                    userSelect: 'none'
                }}
                onClick = { this.checkPayment }
            >MAKE PAYMENT</div>
        } else {
            return <div
                style = {{
                    marginTop: '10px',
                    padding: '15px',
                    textAlign: 'center',
                    width: '50%',
                    borderRadius: '3px',
                    color: '#fff',
                    background: '#ddd',
                    fontWeight: 500,
                    cursor: 'pointer',
                    userSelect: 'none'
                }}
            >MAKE PAYMENT</div>
        }
    }

    showOnwardTripDetails = () => {
        const info = this.props.search.order.length !== 0 ? this.props.search.order.onward : false;
        if (info) {
            return (
                <div className = 'side-info'>
                    <h6>Onward Trip Details</h6>
                    <div className = 'side-det'> { info.companyName } </div><br/>
                    <div className = 'side-det'>
                        <div className="loc-info">
                            { info.fromCity }
                            <br />
                            { this.getCrsDateFormatted(info.journeyDate) + ' - ' + info.boardingTime }
                            <br/>
                            <p style = {{ color: window.color.searchBoxBgColor, width: 'fit-content'}} className = 'pick-label' >
                                Pickup details
                                <span className = 'pick-hover' style={{left:'110%'}}>{ info.boardingTime } | { info.boardingPoint }</span>
                            </p>
                        </div>
                        <div className="arrow_jurny">&#8594;</div>
                        <div className="loc-info">
                            { info.toCity }
                            <br />
                            { this.getCrsDateFormatted(info.arrivalDate) + ' - ' + info.arrivalTime }
                            <br/>
                            <p style = {{ color: window.color.searchBoxBgColor, width: 'fit-content', float: 'right'}} className = 'pick-label' >
                                Drop details
                                <span className = 'pick-hover'>{ info.arrivalTime } | { info.dropPoint }</span>
                            </p>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className = 'side-info'>
                    Loading...
                </div>
            )
        }
    }

    showReturnTripDetails = () => {
        const info = this.props.search.order.return;
        return (
            <div className = 'side-info'>
                <h6>Return Trip Details</h6>
                <div className = 'side-det'> { info.companyName } </div><br/>
                <div className = 'side-det'>
                    <div className="loc-info">
                        { info.fromCity }
                        <br />
                        { this.getCrsDateFormatted(info.journeyDate) + ' - ' + info.boardingTime }
                        <br/>
                        <p style = {{ color: window.color.searchBoxBgColor, width: 'fit-content' }} className = 'pick-label' >
                            Pickup details
                            <span className = 'pick-hover' style={{left:'110%'}}>{ info.boardingTime } | { info.boardingPoint }</span>
                        </p>
                    </div>
                    <div className="arrow_jurny">&#8594;</div>
                    <div className="loc-info">
                        { info.toCity }
                        <br />
                        { this.getCrsDateFormatted(info.arrivalDate) + ' - ' + info.arrivalTime }
                        <br/>
                        <p style = {{ color: window.color.searchBoxBgColor, width: 'fit-content', float: 'right'}} className = 'pick-label' >
                            Drop details
                            <span className = 'pick-hover'>{ info.arrivalTime } | { info.dropPoint }</span>
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    showOnwardPassDetails = () => {
        const loop = this.props.search.order.length !== 0 ? this.props.search.order.onward.seatDetails : false;
        if (loop) {
            return (
                <div className = 'side-info pass'>
                    <h6>Passenger Details { this.props.search.order.return && this.props.search.order.return.seats ? '(Onwards)' : ''}</h6>
                    <div className = 'side-det'>
                        <div>Seat</div>
                        <div>Age</div>
                        <div>Gender</div>
                        <div>Base Fare</div>
                        {/*<div>GST</div>
                        <div>Total Fare</div>*/}
                    </div>
                    { Object.keys(loop).map( el => {
                        return (
                            <div className = 'side-det' key = { el }>
                                <div>{ el }</div>
                                <div>{ loop[el].age }</div>
                                <div>{ loop[el].gender === 'M' ? 'Male' : (loop[el].gender === 'F' ? 'Female' : loop[el].gender) }</div>
                                <div>{this.props.search.currency}{ loop[el].fare - loop[el].serviceTax - loop[el].convenienceCharge }</div>
                                {/*<div>{this.props.search.currency}{ loop[el].serviceTax }</div>
                                <div>{this.props.search.currency}{ loop[el].fare }</div>*/}
                            </div>
                        )
                    }) }
                    
                </div>
            )
        } else {
            return (
                <div className = 'side-info'>
                    Loading...
                </div>
            )
        }
    }

    showReturnPassDetails = () => {
        const loop = this.props.search.order.return.seatDetails;
        return (
            <div className = 'side-info pass'>
                <h6>Passenger Details (Return)</h6>
                <div className = 'side-det'>
                    <div>Seat</div>
                    <div>Age</div>
                    <div>Gender</div>
                    <div>Base Fare</div>
                    {/*<div>GST</div>
                    <div>Total Fare</div>*/}
                </div>
                { Object.keys(loop).map( el => {
                    return (
                        <div className = 'side-det' key = { el }>
                            <div>{ el }</div>
                            <div>{ loop[el].age }</div>
                            <div>{ loop[el].gender === 'M' ? 'Male' : (loop[el].gender === 'F' ? 'Female' : loop[el].gender) }</div>
                            <div>{this.props.search.currency}{ loop[el].fare - loop[el].serviceTax - loop[el].convenienceCharge}</div>
                            {/*<div>{this.props.search.currency}{ loop[el].serviceTax }</div>
                            <div>{this.props.search.currency}{ loop[el].fare }</div>*/}
                        </div>
                    )
                }) }
                
            </div>
        )
    }

    showFareDetails = () => {
        return (
            <div className = 'side-info fare'>
                <h6>Fare Details</h6>
                <div className = 'side-det'>
                    <div>Onward trip fare ({ this.props.search.order.length !== 0 ? this.props.search.order.onward.seats.length : 0 } seats)</div>
                    <div>{this.props.search.currency}{ this.state.onwardFare - this.state.onwardGst - this.state.onwardConvenienceCharge }</div>
                </div>
                {   this.props.search.order.length !== 0 && this.props.search.order.return && this.props.search.order.return.seats ?
                    <div className = 'side-det'>
                        <div>Return trip fare ({ this.props.search.order.return.seats.length } seats)</div>
                        <div>{this.props.search.currency}{ this.state.returnFare - this.state.returnGst - this.state.returnConvenienceCharge }</div>
                    </div>
                    : ''
                }
                <div className = 'side-det'>
                    <div>Convenience charges (non refundable)</div>
                    <div>{this.props.search.currency}{ this.state.onwardConvenienceCharge + this.state.returnConvenienceCharge }</div>
                </div>
                <div className = 'side-det'>
                    <div>GST & Service Charge</div>
                    <div>{this.props.search.currency}{ this.state.onwardGst + this.state.returnGst + this.state.onwardSc + this.state.returnSc }</div>
                </div>
                {
                    this.state.discount > 0 &&
                    <div className = 'side-det'>
                        <div>Discount applied (non refundable)</div>
                        <div>{this.props.search.currency}{ this.state.discount }</div>
                    </div>
                }
                { this.props.search.order.showInsurance ?
                <div className = 'side-det'>
                    <div style = {{ display: 'flex', alignItems: 'center' }}>
                        <Check
                            value = { this.state.insurance }
                            checked = { this.state.insurance === 'on' }
                            handleChange = { this.checkInsurance }
                            style = {{ padding: '1px 5px' }}
                        />
                        Travel insurance&nbsp;
                        <span style = {{ color: window.color.searchBoxBgColor, borderColor: window.color.searchBoxBgColor }} className = 'ins-check extra'>i { this.showInsuranceHover() }</span>
                    </div>
                    <div>{this.props.search.currency}{this.state.insuranceVal}</div>
                </div>
                : ''
                }
                {/* <div className = 'side-det'>
                    <div>Discount</div>
                    <div>{this.props.search.currency}0</div>
                </div> */}
            </div>
        )
    }

    showInsuranceHover = () => {
        return (
            <div className = 'ins-hover'>
                <strong>Super Reliability Service:</strong> Make alternate arrangements if bus services are cancelled including arrangements in upgraded buses.
                <br />
                <br />
                <strong>Free Personal accident Insurance</strong> Coverage of Rs.1,00,000/- (Rupees One Lakh) for death or dismemberment during journey under Personal Accident Policy from <strong>Tata AIG General Insurance Company Ltd</strong>.
            </div>
        )
    }

    getCrsDateFormatted = (val) => {
        const split = val.split('-')
        return split[0] + ' ' + split[1] + ', ' + split[2];
    }

    checkInsurance = (e, i) => {
        const count = this.props.search.order.onward.seats.length + (this.props.search.order.return && this.props.search.order.return.seats ? this.props.search.order.return.seats.length : 0);
        const insurance = this.state.insurance === 'on' ? 'off' : 'on';
        const insuranceVal = this.state.insurance === 'on' ? 0 : count * 20;
        this.setState({ insurance, insuranceVal })
    }

    checkPayment = () => {
        const isGenderCheck = window.location.search.split('p=').length > 1 ? window.location.search.split('p=')[1].split('&')[0] : false;
        
        if (isGenderCheck) {
            let counter = 1;
            const routeCode = this.props.search.order.onward.routeCode;
            const loop = this.props.search.order.onward.seatDetails;
            let url = window.url + '/api/resource/APIGenderValidate?RouteCode=' + routeCode;
            Object.keys(loop).forEach(el => {
                url += ('&SeatLabel_' + counter + '=' + el + '&Gender_' + counter + '=' + (loop[el].gender === 'Male' ? 'M' : 'F'));
                counter++;
            })
            fetchGet(url).then(function(data) {
                const response = JSON.parse(data).APIBooking_GenderValidationResult;
                if (response.Status) {
                    document.getElementById('checkoutForm').submit();
                } else {
                    alert(response.ErrorMessage);
                    window.history.back();
                }
            }).catch(function(error) {
                alert(error);
            });
        } else if (this.props.search.order.onward.seatDetails && this.props.search.order.return && this.props.search.order.return.seatDetails) {
            let genderResponse = { onward: false, return: false };
            // let genderError = { onward: false, return: false };

            if (this.props.search.order.onward.seatDetails) {
                let counter = 1;
                const routeCode = this.props.search.order.onward.routeCode;
                const loop = this.props.search.order.onward.seatDetails;
                let url = window.url + '/api/resource/APIGenderValidate?RouteCode=' + routeCode;
                Object.keys(loop).forEach(el => {
                    url += ('&SeatLabel_' + counter + '=' + el + '&Gender_' + counter + '=' + (loop[el].gender === 'Male' ? 'M' : 'F'));
                    counter++;
                })
                fetchGet(url).then(function(data) {
                    const response = JSON.parse(data).APIBooking_GenderValidationResult;
                    if (response.Status) {
                        genderResponse.onward = true
                    } else {
                        alert('Onward Trip: Seat check validation error. Please change the seat selected and try again.');
                        return;
                    }
                }).catch(function(error) {
                    alert(error);
                });
            }

            if (this.props.search.order.return && this.props.search.order.return.seatDetails) {
                let counter = 1;
                const routeCode = this.props.search.order.return.routeCode;
                const loop = this.props.search.order.return.seatDetails;
                let url = window.url + '/api/resource/APIGenderValidate?RouteCode=' + routeCode;
                Object.keys(loop).forEach(el => {
                    url += ('&SeatLabel_' + counter + '=' + el + '&Gender_' + counter + '=' + (loop[el].gender === 'Male' ? 'M' : 'F'));
                    counter++;
                })
                fetchGet(url).then(function(data) {
                    const response = JSON.parse(data).APIBooking_GenderValidationResult;
                    if (response.Status) {
                        document.getElementById('checkoutForm').submit();
                    } else {
                        alert('Return Trip: Seat check validation error. Please change the seat selected and try again.');
                        return;
                    }
                }).catch(function(error) {
                    alert(error);
                });
            }
        } else {
            document.getElementById('checkoutForm').submit();
        }

        // console.log(routeCode);
        // console.log(this.props.search.order.onward.seatDetails);
        // console.log(this.props.search.order.return.seatDetails);
        // // const url = 'http://www.hanstravel.in/api/resource/APIGenderValidate?RouteCode=21336-24507-52-11-2018-06-19&SeatLabel_1=25&Gender_1=M&SeatLabel_2=26&Gender_2=F&SeatLabel_3=27&Gender_3=F&SeatLabel_4=&Gender_4=&SeatLabel_5=&Gender_5=&SeatLabel_6=&Gender_6=%7BGender_6%7D';
        // fetchGet(url).then(function(data) {
        //     console.log(JSON.parse(data));
        // }).catch(function(error) {
        //     console.log(error);
        // });
        // document.getElementById('checkoutForm').submit()
    }

    render() {
        return (
            <section className = 'checkout-wrapper'>
                <div>
                    <form id = 'checkoutForm' method = 'POST' action = { window.url + '/co/confirm' }>
                        <input type = 'hidden' name = 'query' value = { this.state.queryData } />
                        <input type = 'hidden' name = 'o' id = 'o' value = { this.props.match.params.token } />
                        <input type = 'hidden' name = 'owo' value = '0' />
                        <input type = 'hidden' name = 'method' id = 'method' value = '1' />
                        <input type = 'hidden' name = 'provider' id = 'provider' value = '1' />
                        <input type = 'hidden' name = 'hd_charges' id = 'hd_charges' value = '0' />
                        <input type = 'hidden' name = 'coupon' id = 'coupon' value = '' />
                        { this.enterPassDetailsOnwards() }
                        { this.props.search.order.length !== 0 && this.props.search.order.return && this.props.search.order.return.seats ?this.enterPassDetailsReturn() : '' }
                        { this.enterContactDetails() }
                        { this.props.search.order.showInsurance ?
                        <div style = {{ padding: '25px 0', fontSize: '0.8rem'}}>
                            <Check
                                value = { this.state.insurance }
                                checked = { this.state.insurance === 'on' }
                                handleChange = { this.checkInsurance }
                                style = {{ padding: '7px 5px' }}
                                name = 'insurance'
                            />
                            I would like to purchase a <span style = {{ color: window.color.searchBoxBgColor }} className = 'ins-check'>Travel Insurance { this.showInsuranceHover() }</span> for this purchase (Charge Rs. 20 per person)
                        </div>
                        : ''
                        }
                        { this.selPaymentOption() }
                    </form>
                </div>
                <div>
                    { this.showOnwardTripDetails() }
                    { this.props.search.order.length !== 0 && this.props.search.order.return && this.props.search.order.return.seats ? this.showReturnTripDetails() : '' }
                    { this.showOnwardPassDetails() }
                    { this.props.search.order.length !== 0 && this.props.search.order.return && this.props.search.order.return.seats ? this.showReturnPassDetails() : '' }
                    { this.showFareDetails() }
                    <div className = 'total-fare'>
                        <div>Amount Payable</div>
                        <div>
                            { this.state.discount > 0 && 
                            <strike>{this.props.search.currency}{ this.state.onwardFare + this.state.returnFare + this.state.onwardSc + this.state.returnSc + this.state.insuranceVal} 
                            </strike> } <span>{this.props.search.currency}{ this.state.onwardFare + this.state.returnFare + this.state.onwardSc + this.state.returnSc + this.state.insuranceVal - this.state.discount }</span></div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Checkout);